<template>
  <div class="row_group">
        <div class="group_name"><v-icon v-if="showGroup" v-on:click="toggle_group(groupName)">expand_more</v-icon><v-icon v-if="!showGroup" v-on:click="toggle_group(groupName)">expand_less</v-icon>({{items.length}}) - {{groupName}}</div>
        <div v-if="showGroup"><Row v-for="row in items" v-bind:key="row.spw.ID" :row="row"></Row></div>
    </div>
</template>

<script>
import Row from './Row';
// import Toolbar from './Toolbar';
import { mapState } from 'vuex'
// import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'
import { mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields';

  export default {
    props: ['groupName','items'],
    name: 'RowGroup',
    components: {
      Row,
    },
    data: () => ({
  
    }),
    computed: {
        ...mapState(['groupBy']),
        ...mapFields(['groups']),
        showGroup(){
        if (!(this.groupName in this.groups)){
          return true
        }
        else{
          return this.groups[this.groupName]
        }
      
      }
      // ...mapGetters([''])
    },
    methods:{
      ...mapMutations(['toggle_group']),
      setGroupKey(){

        this.groupkeys[this.groupName] = !this.groupkeys[this.groupName]
      }
    }
  }

</script>
<style>
.group_name{
    background-color:#efefef;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    font-weight: bold;
    /* border-top: solid 1px #cccccc; */
    border-bottom: solid 1px #cccccc;
    border-top: solid 1px white;
}
</style>